import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  DEVICE_SLAVES: 'slaves',
  INFORMATION: 'information',
};

// Exported paths
export const MAIN_PATH = PATHS.DEVICE_SLAVES;
export const INFORMATION_PATH = PATHS.INFORMATION;

// Root
const APP_DEVICE_SLAVES_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_DEVICE_SLAVES_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const showPath = (id) => `${APP_DEVICE_SLAVES_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/deviceSlaves/navigation.js